import { useService } from '@/app/context/DIContext/useService'
import {
    EPGService,
    LoginAndProfileCodespot,
    TVService,
    VODService,
} from '@/shared/constants/servicesConstants'
import { IVODServiceToya } from '@/shared/types/services/types/vodService/vodServiceInterfaces'
import { ITVServiceToya } from '@/shared/types/services/types/tvService/tvServiceInterfaces'
import { IEPGServiceToya } from '@/shared/types/services/types/epgService/epgServiceInterfaces'
import { ILoginAndProfileService } from '@/shared/types/services/types/loginAndProfile/loginAndProfileTypes'
import { IEPGServiceStreamIQ } from '@/shared/types/services/types/epgService/IEPGServiceStreamIQ'
import { IVODServiceStreamIQ } from '@/shared/types/services/types/vodService/IVodServiceStreamIQ'
import { isStreamIQ } from '@/shared/lib'

type EPGServiceType = IEPGServiceStreamIQ | IEPGServiceToya
type VODServiceType = IVODServiceStreamIQ | IVODServiceToya

export const useVODService = () => {
    const vodService = useService<VODServiceType>(VODService)

    if (isStreamIQ()) {
        return vodService as IVODServiceStreamIQ
    } else {
        return vodService as IVODServiceToya
    }
}
export const useTVService = () => useService<ITVServiceToya>(TVService)
export const useEPGService = () => {
    const epgService = useService<EPGServiceType>(EPGService)

    if (isStreamIQ()) {
        return epgService as IEPGServiceStreamIQ
    } else {
        return epgService as IEPGServiceToya
    }
}
export const useLoginAndProfileService = () =>
    useService<ILoginAndProfileService>(LoginAndProfileCodespot)
